import {useUpdateUserLanguageMutation} from "@/api/userApi";
import LanguageSelector from "@/components/Common/LanguageSelector";
import {LANGUAGE_OPTIONS} from "@/store/constants";
import {type FC, memo, useMemo} from "react";
import {useTranslation} from "react-i18next";

const NavbarLanguageSelector: FC = () => {
  const {i18n} = useTranslation();
  const {mutate: updateLanguage, isPending: isUpdatingLanguage} = useUpdateUserLanguageMutation();
  const currentLanguage = useMemo(
    () => LANGUAGE_OPTIONS.find(language => language.i18nextCode === i18n.resolvedLanguage)?.code,
    [i18n.resolvedLanguage],
  );

  return (
    <LanguageSelector
      value={currentLanguage}
      onChange={lang => updateLanguage({lang})}
      isDisabled={isUpdatingLanguage}
      iconClassName="size-5 transition-all duration-150 hover:scale-[1.1] hover:opacity-75"
    />
  );
};

export default memo(NavbarLanguageSelector);
